import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";
const BASE_PATH = `${API_URL}/support/abonnements`;

// Plans
export const fetchPlans = async () => {
  const response = await axios.get(`${BASE_PATH}/plans`);
  return response.data;
};

export const createPlan = async (payload) => {
  const response = await axios.post(`${BASE_PATH}/plans`, payload);
  return response.data;
};

export const updatePlan = async (id, payload) => {
  const response = await axios.put(`${BASE_PATH}/plans/${id}`, payload);
  return response.data;
};

export const deletePlan = async (id) => {
  const response = await axios.delete(`${BASE_PATH}/plans/${id}`);
  return response.data;
};

// Options
export const fetchOptions = async () => {
  const response = await axios.get(`${BASE_PATH}/options`);
  return response.data;
};

export const createOption = async (payload) => {
  const response = await axios.post(`${BASE_PATH}/options`, payload);
  return response.data;
};

export const updateOption = async (id, payload) => {
  const response = await axios.put(`${BASE_PATH}/options/${id}`, payload);
  return response.data;
};

export const deleteOption = async (id) => {
  const response = await axios.delete(`${BASE_PATH}/options/${id}`);
  return response.data;
};

// Invoices
export const fetchInvoices = async (params = {}) => {
  const response = await axios.get(`${BASE_PATH}/invoices`, { params });
  return response.data;
};

export const createInvoice = async (payload) => {
  const response = await axios.post(`${BASE_PATH}/invoices`, payload);
  return response.data;
};

export const updateInvoice = async (id, payload) => {
  const response = await axios.put(`${BASE_PATH}/invoices/${id}`, payload);
  return response.data;
};

export const deleteInvoice = async (id) => {
  const response = await axios.delete(`${BASE_PATH}/invoices/${id}`);
  return response.data;
};

// Payments
export const fetchPayments = async (params = {}) => {
  const response = await axios.get(`${BASE_PATH}/payments`, { params });
  return response.data;
};

export const createPayment = async (payload) => {
  const response = await axios.post(`${BASE_PATH}/payments`, payload);
  return response.data;
};

export const updatePayment = async (id, payload) => {
  const response = await axios.put(`${BASE_PATH}/payments/${id}`, payload);
  return response.data;
};

export const deletePayment = async (id) => {
  const response = await axios.delete(`${BASE_PATH}/payments/${id}`);
  return response.data;
};

// Reminders
export const fetchReminders = async (params = {}) => {
  const response = await axios.get(`${BASE_PATH}/reminders`, { params });
  return response.data;
};

export const createReminder = async (payload) => {
  const response = await axios.post(`${BASE_PATH}/reminders`, payload);
  return response.data;
};

export const updateReminder = async (id, payload) => {
  const response = await axios.put(`${BASE_PATH}/reminders/${id}`, payload);
  return response.data;
};

export const deleteReminder = async (id) => {
  const response = await axios.delete(`${BASE_PATH}/reminders/${id}`);
  return response.data;
};

// Usage logs
export const fetchUsageLogs = async (params = {}) => {
  const response = await axios.get(`${BASE_PATH}/usage`, { params });
  return response.data;
};

export const createUsageLog = async (payload) => {
  const response = await axios.post(`${BASE_PATH}/usage`, payload);
  return response.data;
};

export const updateUsageLog = async (id, payload) => {
  const response = await axios.put(`${BASE_PATH}/usage/${id}`, payload);
  return response.data;
};

export const deleteUsageLog = async (id) => {
  const response = await axios.delete(`${BASE_PATH}/usage/${id}`);
  return response.data;
};

